import templateUrl from './create-modal.html'
import './create-modal.scss'
import {
  RETAINER_TERM_NONE,
  RETAINER_TERM_END_DATE,
  RETAINER_TERM_BILLING_CYCLES,
  localIsoDate,
  minRetainerEndDate
} from '../retainer-term'

const DEFAULT_CREATE_ERROR_MESSAGE = 'Something went wrong. Please, contact Codeable support.'

// Client-side copies of the API's retainer term validation messages, keyed by error field
const RETAINER_TERM_ERROR_MESSAGES = {
  retainer_end_date: 'The end date must be tomorrow or later.',
  retainer_billing_cycles: 'The number of payments must be a whole number greater than 0.'
}

const AdditionalTasksCreateModalComponent = {
  bindings: {},
  templateUrl,
  require: {
    modalCtrl: '^^cdblModal'
  },
  controller: class AdditionalTasksCreateModal {
    constructor ($timeout, ProjectService, AdditionalTasksService, ExperimentService) {
      'ngInject'
      this._identify = 'AdditionalTasksCreateModalComponent'
      this.$timeout = $timeout
      this.ProjectService = ProjectService
      this.AdditionalTasksService = AdditionalTasksService
      this.ExperimentService = ExperimentService

      this.formData = {
        taskType: 'task',
        title: null,
        description: null,
        price: null,
        hourlyRate: null,
        timeEstimate: null,
        billingFrequency: 'monthly',
        scopeCategories: [],
        retainerTerm: RETAINER_TERM_NONE,
        retainerEndDate: null,
        retainerBillingCycles: null
      }

      this.RETAINER_TERM_END_DATE = RETAINER_TERM_END_DATE
      this.RETAINER_TERM_BILLING_CYCLES = RETAINER_TERM_BILLING_CYCLES
      this.retainerTerm = {
        config: {
          type: 'radio-button-outline',
          horizontal: true
        },
        options: [
          { title: 'No end date', value: RETAINER_TERM_NONE },
          { title: 'End date', value: RETAINER_TERM_END_DATE },
          { title: '# of payments', value: RETAINER_TERM_BILLING_CYCLES }
        ]
      }

      this.createError = null
      this.createErrorMessage = null

      this.billingPreview = null

      this.isProcessing = false


      this.temporaryDisableRetainers = this.ExperimentService.isOff('retainer-task-creation')
      this.taskType = {
        config: {
          type: 'radio-button-outline',
          horizontal: true
        },
        options: [
          {
            title: 'Additional Task',
            value: 'task',
            disabled: false
          },
          {
            title: 'Retainer Task',
            value: 'task-retainer',
            disabled: this.temporaryDisableRetainers
          }
        ]
      }

      this.scopeCategories = [
        { value: 'updates', name: 'Updates' },
        { value: 'uptime-monitoring', name: 'Uptime Monitoring' },
        { value: 'backups', name: 'Backups' },
        { value: 'dedicated-development-hours', name: 'Dedicated Development Hours' },
        { value: 'design', name: 'Design' },
        { value: 'content-edits', name: 'Content Edits' },
        { value: 'bug-fixes', name: 'Bug Fixes' },
        { value: 'seo-content-production', name: 'SEO & Content Production' },
        { value: 'performance-optimization', name: 'Performance Optimization' },
        { value: 'analytics-reporting', name: 'Analytics & Reporting' },
        { value: 'support-training-meetings', name: 'Support, Training & Meetings' },
        { value: 'other', name: 'Other' }
      ]
    }

    $onInit () {

    }

    get minRetainerEndDate () {
      return minRetainerEndDate()
    }

    // Sends at most one of the two term fields; an open-ended retainer sends neither
    retainerTermPayload () {
      if (this.formData.retainerTerm === RETAINER_TERM_END_DATE && this.formData.retainerEndDate) {
        return { retainerEndDate: localIsoDate(this.formData.retainerEndDate) }
      }

      if (this.formData.retainerTerm === RETAINER_TERM_BILLING_CYCLES && this.formData.retainerBillingCycles) {
        return { retainerBillingCycles: Number(this.formData.retainerBillingCycles) }
      }

      return {}
    }

    setCreateError (error) {
      const errors = error && error.data && Array.isArray(error.data.errors) ? error.data.errors : []
      const messages = errors.map(err => {
        // The field may arrive snake_case or camelCase
        const field = String(err.field || '').replace(/([A-Z])/g, '_$1').toLowerCase()
        if (RETAINER_TERM_ERROR_MESSAGES[field]) {
          return RETAINER_TERM_ERROR_MESSAGES[field]
        }
        if (!field || field === 'base') {
          return err.message
        }
        const text = `${field.replace(/_/g, ' ')} ${err.message || ''}`.trim()
        return text.charAt(0).toUpperCase() + text.slice(1)
      }).filter(Boolean)

      this.createError = error || true
      this.createErrorMessage = messages.length ? [...new Set(messages)].join(' ') : DEFAULT_CREATE_ERROR_MESSAGE
    }

    onPriceChange () {
      if (!this.ProjectService.project) {
        return
      }

      this.AdditionalTasksService.getBillingPreview(this.ProjectService.project.id, this.formData.price)
        .then(response => {
          console.log('[AdditionalTasksCreateModalComponent] > onPriceChange', response)
          this.billingPreview = response.prices
        })
    }

    createTask () {
      console.log('[AdditionalTasksCreateModalComponent] > postTask', this.formData)

      if (!this.ProjectService.project) {
        console.error('[AdditionalTasksCreateModalComponent] > no project assigned in ProjectService', this.formData)
        return
      }

      this.isProcessing = true
      this.createError = null
      this.createErrorMessage = null
      if (this.formData.taskType === 'task-retainer') {
        const payload = {
          retainer: {
            title: this.formData.title,
            description: this.formData.description,
            price: this.formData.price,
            task_id: this.ProjectService.project.id, // TODO: remove this after BE confirmation
            numberOfHours: this.formData.timeEstimate,
            baseHourlyRate: this.formData.hourlyRate,
            billingFrequency: this.formData.billingFrequency,
            scopeCategories: this.formData.scopeCategories || [],
            ...this.retainerTermPayload()
          }
        }
        this.AdditionalTasksService.createRetainerTask(this.ProjectService.project.id, payload)
          .then(task => {
            // SegmentAnalytics.trackRetainerPosted(task, Auth.me(), parentTask, buttonClicked);
            // $rootScope.$broadcast('sub-task-created', task);
            this.ProjectService.addAdditionalTaskToProject(task, true)
            this.modalCtrl.close()
          })
          .catch(error => {
            console.log('[AdditionalTasksCreateModalComponent] > createRetainerTask > error', error)
            this.setCreateError(error)
          })
          .finally(() => {
            this.isProcessing = false
          })
      } else {
        const payload = {
          title: this.formData.title,
          description: this.formData.description,
          price: this.formData.price,
          numberOfHours: this.formData.timeEstimate,
          baseHourlyRate: this.formData.hourlyRate
        }
        this.AdditionalTasksService.createTask(this.ProjectService.project.id, payload)
          .then(task => {
            // SegmentAnalytics.trackSubtaskPosted(task, Auth.me());
            // $rootScope.$broadcast('sub-task-created', task);
            this.ProjectService.addAdditionalTaskToProject(task, true)
            this.modalCtrl.close()
          })
          .finally(() => {
            this.isProcessing = false
          })
      }
    }
  }
}

export default AdditionalTasksCreateModalComponent
